module.exports = __webpack_public_path__ + "static/media/workingmemory-words-10.9821ad11.mp3";